module.exports = __webpack_public_path__ + "ba4dad6e6b39eba1b210e313b06b036e.jpg";